import { configureStore } from '@reduxjs/toolkit';

import administratorReducer from './administratorSlice';
import atrsImportErrorReducer from './atrsImportErrorSlice';
import commentReducer from './commentSlice';
import exhibitorReducer from './exhibitorSlice';
import inquiryReducer from './inquirySlice';
import notificationReducer from './notificationSlice';
import orderReducer from './orderSlice';
import paymentReducer from './paymentSlice';
import productMasterReducer from './productMasterSlice';
import productReducer from './productSlice';
import requestDetailReducer from './requestDetailSlice';
import requestReducer from './requestSlice';
import satisfactionRatingReducer from './satisfactionRatingSlice';
import unapprovedUserReducer from './unapprovedUserSlice';
import usersReducer from './userSlice';
import carModelReducer from './userStores/carModelsSlice';
import carPartsReducer from './userStores/carPartsSlice';
import carsInfoReducer from './userStores/carsInfoSlice';
import colorReducer from './userStores/colorSlice';
import makersReducer from './userStores/makerSlice';
import uzoneNumberReducer from './uzoneNumberSlice';
import vehicleSpecificationReducer from './vehicleSpecificationSlice';
import withdrawalReducer from './withdrawalSlice';

const store = configureStore({
  reducer: {
    unapprovedUsers: unapprovedUserReducer,
    users: usersReducer,
    requests: requestReducer,
    requestDetail: requestDetailReducer,
    payments: paymentReducer,
    exhibitors: exhibitorReducer,
    orders: orderReducer,
    notifications: notificationReducer,
    comments: commentReducer,
    products: productReducer,
    inquiries: inquiryReducer,
    atrsImportErrors: atrsImportErrorReducer,
    administrators: administratorReducer,
    productsMaster: productMasterReducer,
    withdrawal: withdrawalReducer,
    makers: makersReducer,
    carsInfo: carsInfoReducer,
    carModel: carModelReducer,
    carParts: carPartsReducer,
    color: colorReducer,
    vehicleSpecification: vehicleSpecificationReducer,
    satisfactionRatings: satisfactionRatingReducer,
    uzoneNumber: uzoneNumberReducer,
  },
});

export default store;
